<ds-metadata-field-wrapper *ngIf="(this.collectionsRD$ | async)?.hasSucceeded" [label]="label | translate" [useGcWeb]="true">
    <div class="collections">
        <a *ngFor="let collection of (this.collectionsRD$ | async)?.payload?.page; let last=last;" [routerLink]="['/collections', collection.id]"
          [queryParams]="{ scope: collection.id }">
            <span>{{dsoNameService.getTranslatedName(collection, localeService.getCurrentLanguageCode())?.value}}</span><span *ngIf="!last" [innerHTML]="separator"></span>
        </a>
    </div>
</ds-metadata-field-wrapper>
